// modifer: styles/jss/nextjs-material-kit-pro/pages/ecommerceSections/latestOffersStyle
import { cardTitle, coloredShadow, grayColor, mlAuto } from 'styles/jss/original/base';

import tooltipsStyle from 'styles/jss/nextjs-material-kit-pro/tooltipsStyle.js';

const styles = {
  ...tooltipsStyle,
  coloredShadow,
  card: {
    '@media (max-width: 640px)': {
      marginTop: '0'
    }
  },
  cardBody: {
    textAlign: 'center',
    padding: '0.9375rem 1.25rem 0',
    '@media (max-width: 640px)': {
      padding: '0.9375rem 0.625rem 0'
    }
  },
  cardTitle,
  cardCategory: {
    '@media (max-width: 640px)': {
      marginTop: '5px',
      marginBottom: '0'
    }
  },
  mlAuto,
  price: {
    fontSize: '1.125rem',
    color: grayColor[22],
    '@media (max-width: 640px)': {
      fontSize: '1rem'
    }
  },
  textWrapper: {
    padding: '30px 0',
    textAlign: 'center',
    '@media (max-width: 640px)': {
      padding: '40px 0'
    }
  },
  stats: {
    color: grayColor[0],
    display: 'flex',

    '& svg': {
      width: '24px',
      height: '24px'
    }
  },
  priceContainer: {
    display: 'inline-flex'
  },
  flex: {
    display: 'flex'
  }
};

export default styles;
